module.exports = __webpack_public_path__ + "img/logo.d0bb672b.svg";